export default "__VITE_ASSET__a5c078dd__"